import { combineReducers } from 'redux';
import utils from './utils.reducer';

const utilReducer = combineReducers({
    utils
});

export default utilReducer;


// WEBPACK FOOTER //
// src/main/content/utils/store/reducers/index.js